import { Link } from "@tanstack/react-router";
import { Container, CardMotion } from "@/components/site/Primitives";
import { ResponsiveImage } from "@/components/site/ResponsiveImage";

export type WhoWeServeItem = {
  id?: string;
  name: string;
  body: string;
  image: string;
};

type WhoWeServeSectionProps = {
  items: WhoWeServeItem[];
};

export function WhoWeServeSection({ items }: WhoWeServeSectionProps) {
  if (!items.length) return null;

  return (
    <section id="industries" className="relative bg-stone/40 py-20 md:py-24">
      <Container>
        <h2 className="text-2xl font-semibold tracking-tight text-primary md:text-3xl lg:text-4xl">
          Who we serve
        </h2>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((ind, i) => (
            <Link key={ind.id ?? ind.name} to="/industries" className="group h-full">
              <CardMotion
                animateIndex={i}
                className="flex h-full flex-col overflow-hidden rounded-xl bg-card transition hover:shadow-[0_14px_30px_-18px_rgb(32_56_112/0.3)]"
              >
                <ResponsiveImage
                  src={ind.image}
                  alt={ind.name}
                  loading="lazy"
                  width={800}
                  height={640}
                  widths={[400, 800]}
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 400px"
                  className="aspect-[5/3] w-full object-cover"
                />
                <div className="p-4">
                  <h3 className="text-base font-semibold text-primary">{ind.name}</h3>
                  <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-muted-foreground">
                    {ind.body}
                  </p>
                </div>
              </CardMotion>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}
